module.exports = __webpack_public_path__ + "img/fangkuanzhong.7cd76a15.png";